// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dVatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $DivisiblePricePolicy = tag => ({tag});
const eq = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq2 = /* #__PURE__ */ (() => Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq)();
const eq4 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainersConf.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const AverageIsSymbol = {reflectSymbol: () => "Average"};
const MostExpensiveIsSymbol = {reflectSymbol: () => "MostExpensive"};
const categoryModifiersIsSymbol = {reflectSymbol: () => "categoryModifiers"};
const defaultCrossSellingListIsSymbol = {reflectSymbol: () => "defaultCrossSellingList"};
const defaultPriceParametersIsSymbol = {reflectSymbol: () => "defaultPriceParameters"};
const divisiblePricePolicyIsSymbol = {reflectSymbol: () => "divisiblePricePolicy"};
const divisibleV2IsSymbol = {reflectSymbol: () => "divisibleV2"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const packagingContainersConfigIsSymbol = {reflectSymbol: () => "packagingContainersConfig"};
const vatRateIsSymbol = {reflectSymbol: () => "vatRate"};
const showArray = {show: /* #__PURE__ */ Data$dShow.showArrayImpl(Data$dUUID.toString)};
const ProductCategoryIsSymbol = {reflectSymbol: () => "ProductCategory"};
const decodeArray1 = /* #__PURE__ */ (() => ({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)}))();
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor)(genericEnumConstructor)(genericBottomConstructor);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor)(genericBoundedEnumConstructor);
const encodeWithOptionsOther = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
  return {encodeWithOptions: v => encode1};
})();
const decodeWithOptionsOther = /* #__PURE__ */ (() => {
  const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
  return {decodeWithOptions: v => decode2};
})();
const Average = /* #__PURE__ */ $DivisiblePricePolicy("Average");
const MostExpensive = /* #__PURE__ */ $DivisiblePricePolicy("MostExpensive");
const ProductCategory = x => x;
const toFillFormTypeProductCate = {fillFormDataType: v => "unknown"};
const newtypeProductCategory_ = {Coercible0: () => {}};
const hasFieldProductCategory = dictHasField => dictHasField;
const eqDivisiblePricePolicy = {
  eq: x => y => {
    if (x.tag === "Average") { return y.tag === "Average"; }
    if (x.tag === "MostExpensive") { return y.tag === "MostExpensive"; }
    return false;
  }
};
const eqProductCategory = {
  eq: x => y => eq(x.categoryModifiers)(y.categoryModifiers) && (() => {
    if (x.defaultCrossSellingList.tag === "Nothing") { return y.defaultCrossSellingList.tag === "Nothing"; }
    if (x.defaultCrossSellingList.tag === "Just") {
      if (y.defaultCrossSellingList.tag === "Just") { return x.defaultCrossSellingList._1 === y.defaultCrossSellingList._1; }
      return false;
    }
    return false;
  })() && eq(x.defaultPriceParameters)(y.defaultPriceParameters) && (() => {
    if (x.divisiblePricePolicy.tag === "Average") { return y.divisiblePricePolicy.tag === "Average"; }
    if (x.divisiblePricePolicy.tag === "MostExpensive") { return y.divisiblePricePolicy.tag === "MostExpensive"; }
    return false;
  })() && eq2(x.divisibleV2)(y.divisibleV2) && x.name === y.name && eq4(x.packagingContainersConfig)(y.packagingContainersConfig) && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const ordDivisiblePricePolicy = {
  compare: x => y => {
    if (x.tag === "Average") {
      if (y.tag === "Average") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Average") { return Data$dOrdering.GT; }
    if (x.tag === "MostExpensive") {
      if (y.tag === "MostExpensive") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqDivisiblePricePolicy
};
const genericProductCategory = {to: x => x, from: x => x};
const genericDivisiblePricePolicy = {
  to: x => {
    if (x.tag === "Inl") { return Average; }
    if (x.tag === "Inr") { return MostExpensive; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Average") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "MostExpensive") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showDivisiblePricePolicy = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AverageIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(MostExpensiveIsSymbol);
    return x => {
      if (x.tag === "Average") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "MostExpensive") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const showProductCategory = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
      return {
        genericShowArgs: v => [
          "{ categoryModifiers: " + showArray.show(v.categoryModifiers) + (() => {
            if (v.defaultCrossSellingList.tag === "Just") {
              return ", defaultCrossSellingList: (Just " + v.defaultCrossSellingList._1 + ")" + ", defaultPriceParameters: " + showArray.show(v.defaultPriceParameters) + ", divisiblePricePolicy: " + showDivisiblePricePolicy.show(v.divisiblePricePolicy) + ", divisibleV2: " + $0.show(v.divisibleV2) + ", name: " + Data$dShow.showStringImpl(v.name) + (() => {
                if (v.packagingContainersConfig.tag === "Just") {
                  return ", packagingContainersConfig: (Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfig._1) + ")" + (() => {
                    if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
                    if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
                    $runtime.fail();
                  })();
                }
                if (v.packagingContainersConfig.tag === "Nothing") {
                  if (v.vatRate.tag === "Just") {
                    return ", packagingContainersConfig: Nothing, vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") ";
                  }
                  if (v.vatRate.tag === "Nothing") { return ", packagingContainersConfig: Nothing, vatRate: Nothing "; }
                  $runtime.fail();
                }
                $runtime.fail();
              })();
            }
            if (v.defaultCrossSellingList.tag === "Nothing") {
              return ", defaultCrossSellingList: Nothing, defaultPriceParameters: " + showArray.show(v.defaultPriceParameters) + ", divisiblePricePolicy: " + showDivisiblePricePolicy.show(v.divisiblePricePolicy) + ", divisibleV2: " + $0.show(v.divisibleV2) + ", name: " + Data$dShow.showStringImpl(v.name) + (() => {
                if (v.packagingContainersConfig.tag === "Just") {
                  return ", packagingContainersConfig: (Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfig._1) + ")" + (() => {
                    if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
                    if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
                    $runtime.fail();
                  })();
                }
                if (v.packagingContainersConfig.tag === "Nothing") {
                  if (v.vatRate.tag === "Just") {
                    return ", packagingContainersConfig: Nothing, vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") ";
                  }
                  if (v.vatRate.tag === "Nothing") { return ", packagingContainersConfig: Nothing, vatRate: Nothing "; }
                  $runtime.fail();
                }
                $runtime.fail();
              })();
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(ProductCategoryIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDivisiblePricePolicy = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericDivisiblePricePolicy)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Average"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("MostExpensive"), Data$dGeneric$dRep.NoArguments)]}))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodeProductCategory = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(categoryModifiersIsSymbol)(decodeArray1)(Unscramble.decodeRecordCons(defaultCrossSellingListIsSymbol)(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons(defaultPriceParametersIsSymbol)(decodeArray1)(Unscramble.decodeRecordCons(divisiblePricePolicyIsSymbol)(unscrambleDecodeDivisiblePricePolicy)(Unscramble.decodeRecordCons(divisibleV2IsSymbol)(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1))(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(packagingContainersConfigIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainersConfig))(Unscramble.decodeRecordCons(vatRateIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dVatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const boundedDivisiblePricePoli = {top: MostExpensive, bottom: Average, Ord0: () => ordDivisiblePricePolicy};
const enumDivisiblePricePolicy = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericDivisiblePricePolicy)(genericEnumSum),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericDivisiblePricePolicy)(genericEnumSum),
  Ord0: () => ordDivisiblePricePolicy
};
const boundedEnumDivisiblePrice = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericDivisiblePricePolicy)(genericBoundedEnumSum),
    fromEnum: x => genericBoundedEnumSum["genericFromEnum'"]((() => {
      if (x.tag === "Average") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "MostExpensive") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    })()),
    Bounded0: () => boundedDivisiblePricePoli,
    Enum1: () => enumDivisiblePricePolicy
  }
))();
const toFillFormTypeDivisiblePr = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericDivisiblePricePolicy)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Average\""
  })({gdefaultEnumFillFormDataType: v => "\"MostExpensive\""}))
};
const encodeDivisiblePricePolicy = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericDivisiblePricePolicy)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Average"); }
      if (v1.tag === "Inr") { return v.constructorTagTransform("MostExpensive"); }
      $runtime.fail();
    }
  })
};
const encodeProductCategory = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductCategory)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ProductCategoryIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(vatRateIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dVatRate.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))(packagingContainersConfigIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainersConfig.encode(v2._1); }
        $runtime.fail();
      }
    }))(nameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(divisibleV2IsSymbol)((() => {
      const encode1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      }).encode;
      return {encodeWithOptions: v => encode1};
    })()))(divisiblePricePolicyIsSymbol)({encodeWithOptions: v => encodeDivisiblePricePolicy.encode}))(defaultPriceParametersIsSymbol)(encodeWithOptionsOther))(defaultCrossSellingListIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(categoryModifiersIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeDivisiblePricePolicy = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericDivisiblePricePolicy)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(AverageIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(MostExpensiveIsSymbol)))
};
const decodeProductCategory = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductCategory)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ProductCategoryIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(vatRateIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dVatRate.decodeVatRate.decode)
  })())(packagingContainersConfigIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainersConfig.decode)
  })())(nameIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())(divisibleV2IsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode;
    return {decodeWithOptions: v => decode2};
  })())())(divisiblePricePolicyIsSymbol)({decodeWithOptions: v => decodeDivisiblePricePolicy.decode})())(defaultPriceParametersIsSymbol)(decodeWithOptionsOther)())(defaultCrossSellingListIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())(categoryModifiersIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $DivisiblePricePolicy,
  Average,
  AverageIsSymbol,
  MostExpensive,
  MostExpensiveIsSymbol,
  ProductCategory,
  ProductCategoryIsSymbol,
  boundedDivisiblePricePoli,
  boundedEnumDivisiblePrice,
  categoryModifiersIsSymbol,
  decodeArray1,
  decodeDivisiblePricePolicy,
  decodeProductCategory,
  decodeWithOptionsOther,
  defaultCrossSellingListIsSymbol,
  defaultPriceParametersIsSymbol,
  divisiblePricePolicyIsSymbol,
  divisibleV2IsSymbol,
  encodeDivisiblePricePolicy,
  encodeProductCategory,
  encodeWithOptionsOther,
  enumDivisiblePricePolicy,
  eq,
  eq2,
  eq4,
  eqDivisiblePricePolicy,
  eqProductCategory,
  genericBottomConstructor,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericDivisiblePricePolicy,
  genericEnumConstructor,
  genericEnumSum,
  genericProductCategory,
  genericTopConstructor,
  hasFieldProductCategory,
  nameIsSymbol,
  newtypeProductCategory_,
  ordDivisiblePricePolicy,
  packagingContainersConfigIsSymbol,
  showArray,
  showDivisiblePricePolicy,
  showProductCategory,
  toFillFormTypeDivisiblePr,
  toFillFormTypeProductCate,
  unscrambleDecodeDivisiblePricePolicy,
  unscrambleDecodeProductCategory,
  vatRateIsSymbol
};
